// Types
// eslint-disable-next-line import/prefer-default-export
export const types = {
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
};
